// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quote .content[data-v-4bf5734d]{background-color:#f3f6f8;border-radius:.4rem;padding:1rem}.quote .content .icon-left[data-v-4bf5734d],.quote .content .icon-right[data-v-4bf5734d]{color:#bed0d3;font-size:2rem}.quote .content p[data-v-4bf5734d]{color:#616e71;font-style:italic;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
